const DIGITS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
const ZERO = DIGITS[0];
const LARGEST_DIGIT = DIGITS[DIGITS.length - 1];
const SMALLEST_INTEGER = "A" + ZERO.repeat(26);
const JITTER_BITS = 16;
function getIntegerLength(head) {
  if (head >= "a" && head <= "z") {
    return head.charCodeAt(0) - "a".charCodeAt(0) + 2;
  } else if (head >= "A" && head <= "Z") {
    return "Z".charCodeAt(0) - head.charCodeAt(0) + 2;
  }
  throw new Error("invalid order key head: " + head);
}
function getIntegerPart(key) {
  const integerPartLength = getIntegerLength(key[0]);
  if (integerPartLength > key.length) {
    throw new Error("invalid order key: " + key);
  }
  return key.slice(0, integerPartLength);
}
function digitIndex(char) {
  const code = char.charCodeAt(0);
  if (code <= 57) return code - 48;
  if (code <= 90) return code - 55;
  return code - 61;
}
function validateOrderKey(key) {
  if (key === SMALLEST_INTEGER) {
    throw new Error("invalid order key: " + key);
  }
  const i = getIntegerPart(key);
  if (key.length > i.length && key[key.length - 1] === ZERO) {
    throw new Error("invalid order key: " + key);
  }
}
function midpoint(a, b) {
  if (b != null && a >= b) {
    throw new Error(a + " >= " + b);
  }
  if (a.slice(-1) === ZERO || b && b.slice(-1) === ZERO) {
    throw new Error("trailing zero");
  }
  if (b) {
    let n = 0;
    while ((a[n] || ZERO) === b[n]) {
      n++;
    }
    if (n > 0) {
      return b.slice(0, n) + midpoint(a.slice(n), b.slice(n));
    }
  }
  const digitA = a ? digitIndex(a[0]) : 0;
  const digitB = b != null ? digitIndex(b[0]) : DIGITS.length;
  if (digitB - digitA > 1) {
    const midDigit = Math.round(0.5 * (digitA + digitB));
    return DIGITS[midDigit];
  }
  if (b && b.length > 1) {
    return b.slice(0, 1);
  }
  return DIGITS[digitA] + midpoint(a.slice(1), null);
}
function incrementInteger(x) {
  const [head, ...digs] = x.split("");
  let carry = true;
  for (let i = digs.length - 1; carry && i >= 0; i--) {
    const d = digitIndex(digs[i]) + 1;
    if (d === DIGITS.length) {
      digs[i] = ZERO;
    } else {
      digs[i] = DIGITS[d];
      carry = false;
    }
  }
  if (carry) {
    if (head === "Z") return "a" + ZERO;
    if (head === "z") return null;
    const h = String.fromCharCode(head.charCodeAt(0) + 1);
    if (h > "a") {
      digs.push(ZERO);
    } else {
      digs.pop();
    }
    return h + digs.join("");
  }
  return head + digs.join("");
}
function decrementInteger(x) {
  const [head, ...digs] = x.split("");
  let borrow = true;
  for (let i = digs.length - 1; borrow && i >= 0; i--) {
    const d = digitIndex(digs[i]) - 1;
    if (d === -1) {
      digs[i] = LARGEST_DIGIT;
    } else {
      digs[i] = DIGITS[d];
      borrow = false;
    }
  }
  if (borrow) {
    if (head === "a") return "Z" + LARGEST_DIGIT;
    if (head === "A") return null;
    const h = String.fromCharCode(head.charCodeAt(0) - 1);
    if (h < "Z") {
      digs.push(LARGEST_DIGIT);
    } else {
      digs.pop();
    }
    return h + digs.join("");
  }
  return head + digs.join("");
}
function keyBetweenUnchecked(a, b) {
  if (a != null && b != null && a >= b) {
    throw new Error(a + " >= " + b);
  }
  if (a == null) {
    if (b == null) return "a" + ZERO;
    const ib2 = getIntegerPart(b);
    const fb2 = b.slice(ib2.length);
    if (ib2 === SMALLEST_INTEGER) {
      return ib2 + midpoint("", fb2);
    }
    if (ib2 < b) return ib2;
    const res = decrementInteger(ib2);
    if (res == null) throw new Error("cannot decrement any more");
    return res;
  }
  if (b == null) {
    const ia2 = getIntegerPart(a);
    const fa2 = a.slice(ia2.length);
    const i2 = incrementInteger(ia2);
    return i2 == null ? ia2 + midpoint(fa2, null) : i2;
  }
  const ia = getIntegerPart(a);
  const fa = a.slice(ia.length);
  const ib = getIntegerPart(b);
  const fb = b.slice(ib.length);
  if (ia === ib) {
    return ia + midpoint(fa, fb);
  }
  const i = incrementInteger(ia);
  if (i == null) throw new Error("cannot increment any more");
  if (i < b) return i;
  return ia + midpoint(fa, null);
}
function nKeysBetweenUnchecked(a, b, n) {
  if (n === 0) return [];
  if (n === 1) return [keyBetweenUnchecked(a, b)];
  if (b == null) {
    let c2 = keyBetweenUnchecked(a, b);
    const result = [c2];
    for (let i = 0; i < n - 1; i++) {
      c2 = keyBetweenUnchecked(c2, b);
      result.push(c2);
    }
    return result;
  }
  if (a == null) {
    let c2 = keyBetweenUnchecked(a, b);
    const result = [c2];
    for (let i = 0; i < n - 1; i++) {
      c2 = keyBetweenUnchecked(a, c2);
      result.push(c2);
    }
    result.reverse();
    return result;
  }
  const mid = Math.floor(n / 2);
  const c = keyBetweenUnchecked(a, b);
  return [...nKeysBetweenUnchecked(a, c, mid), c, ...nKeysBetweenUnchecked(c, b, n - mid - 1)];
}
function jitterBetween(low, high) {
  let mid = keyBetweenUnchecked(low, high);
  for (let i = 0; i < JITTER_BITS; i++) {
    if (Math.random() < 0.5) {
      low = mid;
    } else {
      high = mid;
    }
    mid = keyBetweenUnchecked(low, high);
  }
  return mid;
}
function generateNJitteredKeysBetween(a, b, n) {
  if (n === 0) return [];
  if (a != null) validateOrderKey(a);
  if (b != null) validateOrderKey(b);
  const keys = nKeysBetweenUnchecked(a, b, n + 1);
  const result = new Array(n);
  for (let i = 0; i < n; i++) {
    result[i] = jitterBetween(keys[i], keys[i + 1]);
  }
  return result;
}
function generateNKeysBetween(a, b, n) {
  if (n === 0) return [];
  if (a != null) validateOrderKey(a);
  if (b != null) validateOrderKey(b);
  return nKeysBetweenUnchecked(a, b, n);
}
export {
  generateNJitteredKeysBetween,
  generateNKeysBetween,
  validateOrderKey
};
//# sourceMappingURL=fractionalIndexing.mjs.map
